import React, { useEffect, useMemo } from 'react';
import { Box, FlexControlledForm, useDebounceState } from '@common-fe/common-fe';
import styled from 'styled-components';

import ConfigureButton from '../../ConfigureButton';
import { usePreviewStore, useSubmitFormStore } from '../../stores';

import useAccountFundingParamsFieldsLegacy from './hooks/useAccountFundingParamsFieldsLegacy';
import { useFundingMethodsFeatureFlag } from './hooks/useFundingMethodsFeatureFlag';
import { AccountFundingParamsPayload,useStore } from './stores/useAccountFundingParams.store';
import { useAccountFundingParamsFields } from './hooks';

const Wrapper = styled(Box)`
  &:last-child {
    margin-bottom: 0 ;
  }
`;
interface Props {
  isEditMode?: boolean;
  isTemplateMode?: boolean;
  onDirty?: (isDirty: boolean) => void;
  isTerminated?: boolean;
}
const AccountFunding: React.FC<Props> = ({ isEditMode, onDirty, isTemplateMode, isTerminated }) => {
  const activateValidate = useSubmitFormStore((state) => state.activateValidate);
  const previewMode = usePreviewStore((state) => state.previewMode);

  const isFundingMethodsFF = useFundingMethodsFeatureFlag();
  const fields = useAccountFundingParamsFields(activateValidate, isTemplateMode, isEditMode);
  const legacyFields = useAccountFundingParamsFieldsLegacy(activateValidate, isTemplateMode, isEditMode);
  const handleSetState = useStore((state) => state.setState);
  const showErrors = useStore((state) => state.showErrors);

  const currentFields = useMemo(
    () => (isFundingMethodsFF ? fields : legacyFields),
    [fields, isFundingMethodsFF, legacyFields]
  );

  const { setValues, values } = useDebounceState<Partial<AccountFundingParamsPayload>>();
  useEffect(() => {
    if (values) {
      handleSetState(values);
    }
  }, [handleSetState, values]);
  if (!fields.length) {
    return null;
  }
  return (

    <Wrapper background="canvas" margin={{ top: 'spacing24' }} round="container1Round">
      <FlexControlledForm
        formTitle="Financial details"
        testId="plan_account-funding"
        fields={currentFields}
        showError={showErrors}
        editMode={isEditMode}
        onChangeValues={setValues}
        isThinMode
        onDirty={onDirty}
        footer={!isEditMode && !previewMode && !isTerminated && (
          <ConfigureButton isTemplateMode={isTemplateMode} />
        )}
      />

    </Wrapper>
  );
};

export default AccountFunding;
